import React from 'react';
import classNames from 'classnames';

// Components
import { Button } from '@capintel/component-lib/button';
import { SecondaryLink } from '../../../../components/buttons';

// Utils
import { FormattedMessage } from '../../../../../utils/i18n';

// Images
import { ReactComponent as TwoFactorAuthImg } from '../../../../../images/two-factor-auth.svg?react';

type Props = {
  gracePeriod?: number;
  feedback?: React.ReactNode;
  helpUrl: string;
  loading: boolean;
  variant?: 'Default' | 'MandatorySetup';
  primaryAction: () => void;
  onCancel?: () => void;
};

const BeginStep = ({ feedback, gracePeriod, helpUrl, variant = 'Default', onCancel, loading, primaryAction }: Props) => (
  <div className={classNames('two-factor-step-content', 'two-factor-begin-step', `variant-${variant}`)}>
    <div className="two-factor-auth-image">
      <TwoFactorAuthImg />
    </div>
    {feedback && <p className="two-factor-auth-feedback">{feedback}</p>}
    <h3 className="two-factor-auth-header">
      <FormattedMessage id={`TwoFactorAuthentication.Headers.ProtectYourAccount.${variant}`} values={{ br: <br /> }} />
    </h3>
    <p className="two-factor-auth-text">
      <FormattedMessage id="TwoFactorAuthentication.Texts.AddAnAdditionalLayer" />
      &nbsp;
      <a rel="noreferrer" target="_blank" href={helpUrl}>
        <FormattedMessage id="TwoFactorAuthentication.Buttons.FindOutMore" />
      </a>
    </p>

    <div className="two-factor-actions">
      <Button variant="primary" loading={loading} onClick={primaryAction}>
        <FormattedMessage id="TwoFactorAuthentication.Buttons.GetStarted" />
      </Button>
      {onCancel &&
        (!gracePeriod ? (
          <SecondaryLink onClick={onCancel}>
            <FormattedMessage id="TwoFactorAuthentication.Buttons.ContinueWithout" />
          </SecondaryLink>
        ) : (
          <p>
            <FormattedMessage id="TwoFactorAuthentication.Texts.GracePeriod" values={{ count: gracePeriod }} />
            <SecondaryLink onClick={onCancel}>
              <FormattedMessage id="TwoFactorAuthentication.Buttons.SkipForNow" />
            </SecondaryLink>
          </p>
        ))}
    </div>
  </div>
);

export default BeginStep;
